export function _getBaseUrl() {
  //console.dir(process.env)

  if (process.env.NEXT_PUBLIC_ARI_API_HOST && process.env.NEXT_PUBLIC_ARI_API_PORT) {
    //console.log('ARI_API_HOST', process.env.NEXT_PUBLIC_ARI_API_HOST)
    //console.log('ARI_API_PORT', process.env.NEXT_PUBLIC_ARI_API_PORT)
    return `${process.env.NEXT_PUBLIC_ARI_API_HOST}:${process.env.NEXT_PUBLIC_ARI_API_PORT}`
  }

  // assume localhost
  return `http://localhost:${process.env.PORT ?? 8000}`
}

export function getBaseUrl() {
  const url = _getBaseUrl()
  return url
}
